@if (subpanelList?.length) {
  <div class="ub-search-filter">
    @for (ele of subpanelList; track ele) {
      @for (control of ele?.controls; track control) {
        <!-- DROPDOWN -->
        @if (control?.type == 'dropdown') {
          <mat-form-field
            appearance="outline"
            class="ub-form-select"
            >
            <mat-select
              [(value)]="selectedSubpanel"
              [placeholder]="control?.placeholder | translate"
                (selectionChange)="
                  selectionChange({ key: $event?.value?.key, value: $event?.value.label })
                "
              >
              @for (data of control?.dataset; track data) {
                <mat-option
                  [value]="data"
                  >
                  {{ data?.label | translate }} {{ data?.sub_label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <!-- END DROPDOWN -->
        @if (control?.type == 'selectedValue') {
          <div class="filter-input-container">
            <div class="custom-mat-form-field">
              <span class="readonly-select" aria-placeholder="Target Subpanel Name">
                {{ selectedValue }}
              </span>
            </div>
          </div>
        }
      }
    }
  </div>
}